import { createContext, ReactElement, ReactNode, useContext, useMemo, useState } from 'react';
import { Filters } from '../../models';

interface FiltersContextType {
  filters: Filters | null;
  setFilters: (filters: Filters | null) => void;
}

const FiltersContext = createContext<FiltersContextType>({
  filters: null,
  setFilters: () => {},
});
export const useFiltersContext = (): FiltersContextType => useContext(FiltersContext);

interface FiltersProviderProps {
  children: ReactNode;
}

const FiltersProvider = ({ children }: FiltersProviderProps): ReactElement => {
  const [filters, setFilters] = useState<Filters | null>(null);

  const filterProps = useMemo(() => {
    return {
      filters,
      setFilters: (filters: Filters | null) => {
        setFilters(filters);
      },
    };
  }, [filters]);

  return <FiltersContext.Provider value={filterProps}>{children}</FiltersContext.Provider>;
};

export default FiltersProvider;
